import { bootstrap } from '/core/Barba'
import { openHash } from '/components/Projects'
import mediaReady from '/utils/media-ready'

;(async () => {
  bootstrap({
    views: [
      await import('/views/default')
    ],

    components: {
      // Outside barba wrapper
      global: [
        await import('/components/Menu')
      ],

      // Inside barba wrapper
      local: [
        await import('/components/Projects')
      ]
    },

    afterEnter: async next => {
      // Update manually as Barba payload does not include <header>
      document.title = next.container.dataset.title

      // Flag native lazy loading so that we can animate in CSS
      Promise.all(Array.from(next.container.querySelectorAll('video, [loading="lazy"]')).map(async el => {
        await mediaReady(el)
        el.classList.add('is-loaded')
      }))

      // Open the matching project, if any, and scroll to it. `Barba.js` has
      // already made sure window.location.hash reflects where the visitor
      // actually navigated to by this point (its own history handling
      // would otherwise strip it).
      const target = window.location.hash ? openHash(next.container) : null
      if (target) {
        // Wait a frame: right after a Barba page swap the new container
        // hasn't been laid out/painted yet, so scrollIntoView would measure
        // a stale (often much shorter) page and land past the real target.
        requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }))
      } else if (!window.location.hash) {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
      }
    }
  })
})()
